import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const ElementPropertyValue = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  targetElementPersistentId: z.string(),
  definitionPersistentId: z.string(),
  stringValue: z.string().nullish(),
  numberValue: z.number().nullish(),
  booleanValue: z.boolean().nullish(),
  referenceValue: z.string().nullish(),
  referenceValuePreview: z.string().optional(),
});

export type ElementPropertyValue = z.infer<typeof ElementPropertyValue>;

export type CreateElementPropertyValue = DbCreateInputOmit<ElementPropertyValue>;
export type UpdateElementPropertyValue = OmitStrict<
  DbUpdate<ElementPropertyValue>,
  "designSystemVersionId" | "definitionPersistentId" | "targetElementPersistentId"
>;

export type ElementPropertyValueDiff = {
  toCreate: CreateElementPropertyValue[];
  toUpdate: UpdateElementPropertyValue[];
  toDelete: ElementPropertyValue[];
};
